/* WTF "Pairs great with" measurement, 2026-10-13 (Jeff terminal 5:4x PM AZ: "make sure we have tracking on the clicks people make on the pairs with section in the cart. I need to know how successful that area ends up being.")
   Loaded by snippets/cart-drawer.liquid on every page (defer). No dependency. Every failure is silent: nothing here may break the cart or a product page.

   WHAT IT WRITES (all private: names start with "_wtf_", so the customer never sees them and Printify/Printful do not get them):
   1) Line item properties on a one-tap carousel Add: _wtf_src = cart_pairs, _wtf_pairs_pos = 1..6. Added by assets/wtf-drawer-v2.js in the same /cart/add call.
   2) Product page add after a carousel "Personalize" / "View" tap: the card links carry ?wtf_src=cart_pairs&wtf_pos=N (stamped here). On that product page, the same two
      properties are put into the add-to-cart form at submit time. Only when the page was LOADED with those params. Nothing changes on any other product page.
   3) Cart attributes, written with POST /cart/update.js (merge, other attributes stay): _wtf_pairs_seen = 1, _wtf_pairs_clicks = running count, _wtf_pairs_adds = running count.
      Debounced: the first pending change starts an 8 s timer, one call per timer. A page that is hiding or unloading sends the pending change at once (keepalive).
   4) Shopify.analytics.publish('wtf_pairs_click', {...}) on every carousel tap, for a future pixel. No pixel is added here.
   5) PRODUCT-PAGE SUGGESTIONS (build 1e, 2026-10-14, Jeff terminal: "Add tracking for blanket adds on the product page"). The product page only LINKS to other products
      (the House Divided "View Matching Blanket" card, snippets/wtf-hd-bundle-upsell.liquid, and the "You may also like" grid, sections/related-products.liquid). Neither has an add button.
      So, at click time only (the rendered HTML is unchanged), a click on one of those links adds ?wtf_src=pdp_suggest&wtf_from=<source handle>&wtf_pblk=<hd_card|related>&wtf_ppos=<n>.
      The landing product page then puts these hidden properties into the add-to-cart form at submit time: _wtf_src = pdp_suggest, _wtf_src_from = <source handle>,
      _wtf_pdp_blk = <hd_card|related>, _wtf_pdp_pos = <n>. Only when the page was LOADED with those params. Shop Pay / Buy it now bypass the form and are not tagged.
   Counts include arrow taps (the customer event carries the kind, so arrows can be separated there). Never touches checkout. Never blocks a click. */
(function () {
  'use strict';
  if (window.__wtfPairsTrack) return;
  window.__wtfPairsTrack = true;

  var SRC = 'cart_pairs';
  var SRC2 = 'pdp_suggest';
  var BLKS = { hd_card: 1, related: 1 };
  var HANDLE_RX = /^[a-z0-9][a-z0-9_-]{0,254}$/i;
  var GAP = 8000;
  var MAXPOS = 6;
  var MAXSUG = 12;

  function num(v) { var n = parseInt(v, 10); return isFinite(n) && n > 0 ? n : 0; }
  function productHandle() { var m = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^\/?#]+)/i.exec(location.pathname); return m ? m[1] : ''; }

  /* ---------- Product page: carry the carousel tag into the add-to-cart form ---------- */
  var pageTag = null;   /* { props: [[name, value], ...] } put into the add-to-cart form at submit time */
  try {
    var q = new URLSearchParams(location.search);
    var p = num(q.get('wtf_pos'));
    var here = productHandle();
    if (q.get('wtf_src') === SRC && p >= 1 && p <= MAXPOS && here) {
      pageTag = { props: [['properties[_wtf_src]', SRC], ['properties[_wtf_pairs_pos]', String(p)]] };
    } else if (q.get('wtf_src') === SRC2 && here) {
      var from = q.get('wtf_from') || '', blk = q.get('wtf_pblk') || '', pp = num(q.get('wtf_ppos'));
      if (HANDLE_RX.test(from) && from.toLowerCase() !== here.toLowerCase() && BLKS[blk] === 1 && pp >= 1 && pp <= MAXSUG) {
        pageTag = { props: [['properties[_wtf_src]', SRC2], ['properties[_wtf_src_from]', from], ['properties[_wtf_pdp_blk]', blk], ['properties[_wtf_pdp_pos]', String(pp)]] };
      }
    }
  } catch (e) { pageTag = null; }

  function putHidden(form, name, value) {
    var sel = 'input[type="hidden"][data-wtf-pairs][name="' + name + '"]';
    var el = form.querySelector(sel);
    if (!el) {
      el = document.createElement('input');
      el.type = 'hidden';
      el.name = name;
      el.setAttribute('data-wtf-pairs', '');
      form.appendChild(el);
    }
    el.value = value;
  }
  if (pageTag) {
    /* Capture phase on document: runs before the theme's own submit handler builds its FormData. */
    document.addEventListener('submit', function (e) {
      try {
        var f = e.target;
        if (!f || !f.matches || !f.matches('form[action*="/cart/add"]')) return;
        if ((f.getAttribute('id') || '').indexOf('installment') !== -1) return;   /* f.id would be the <input name="id"> inside the form */
        for (var k = 0; k < pageTag.props.length; k++) putHidden(f, pageTag.props[k][0], pageTag.props[k][1]);
      } catch (err) { /* never block the add */ }
    }, true);
  }

  /* ---------- Product page: tag the links to other products (suggestions) at click time ---------- */
  var SUG = [
    { sel: '[data-wtf-hdu="shirt"]', blk: 'hd_card', item: '' },
    { sel: 'product-recommendations.related-products', blk: 'related', item: 'li.grid__item' }
  ];
  function stampSuggest(e) {
    try {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var a = t.closest('a[href]');
      if (!a) return;
      var cur = productHandle();
      if (!cur) return;                                   /* only on a product page */
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#') return;
      var u = new URL(h, location.origin);
      var m = /^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?products\/([^\/?#]+)/i.exec(u.pathname);
      if (u.origin !== location.origin || !m || m[1].toLowerCase() === cur.toLowerCase()) return;
      for (var i = 0; i < SUG.length; i++) {
        var box = a.closest(SUG[i].sel);
        if (!box) continue;
        var pos = 1;
        if (SUG[i].item) {
          var it = a.closest(SUG[i].item);
          if (!it || !it.parentNode) return;
          pos = Array.prototype.indexOf.call(it.parentNode.children, it) + 1;
          if (pos < 1) return;
        }
        u.searchParams.set('wtf_src', SRC2);
        u.searchParams.set('wtf_from', cur);
        u.searchParams.set('wtf_pblk', SUG[i].blk);
        u.searchParams.set('wtf_ppos', String(Math.min(pos, MAXSUG)));
        a.setAttribute('href', u.pathname + u.search);
        return;
      }
    } catch (err) { /* leave the link as rendered */ }
  }
  document.addEventListener('click', stampSuggest, true);
  document.addEventListener('auxclick', stampSuggest, true);   /* middle click: open in a new tab */

  /* ---------- Cart drawer: stamp positions on the card links ---------- */
  function setParams(a, pos) {
    try {
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) === '#') return;
      var u = new URL(h, location.origin);
      if (u.origin !== location.origin || !/\/products\//.test(u.pathname)) return;
      u.searchParams.set('wtf_src', SRC);
      u.searchParams.set('wtf_pos', String(pos));
      a.setAttribute('href', u.pathname + u.search);
    } catch (e) { /* leave the link as rendered */ }
  }
  function posOf(card) {
    if (!card || !card.parentNode) return 0;
    var i = Array.prototype.indexOf.call(card.parentNode.children, card) + 1;
    return i > 0 ? Math.min(i, MAXPOS) : 0;
  }
  function stamp(w) {
    var cards = w.querySelectorAll('.wtf-up__card');
    for (var i = 0; i < cards.length; i++) {
      var pos = Math.min(i + 1, MAXPOS);
      cards[i].setAttribute('data-wtf-pos', String(pos));
      var links = cards[i].querySelectorAll('a[href]');
      for (var j = 0; j < links.length; j++) setParams(links[j], pos);
    }
  }

  /* ---------- Cart drawer: counters and the debounced cart-attribute write ---------- */
  var known = { seen: false, clicks: 0, adds: 0 };   /* what the server last told us */
  var pend = { seen: false, clicks: 0, adds: 0 };    /* not yet written */
  var timer = 0, inflight = false;

  function syncKnown(w) {
    if (timer || inflight || pend.seen || pend.clicks || pend.adds) return;   /* never overwrite counts that are waiting to be written */
    known.seen = w.getAttribute('data-pairs-seen') === '1';
    known.clicks = num(w.getAttribute('data-pairs-clicks'));
    known.adds = num(w.getAttribute('data-pairs-adds'));
  }
  function payload() {
    return {
      attributes: {
        _wtf_pairs_seen: '1',
        _wtf_pairs_clicks: String(known.clicks + pend.clicks),
        _wtf_pairs_adds: String(known.adds + pend.adds)
      }
    };
  }
  function hasPending() { return pend.seen || pend.clicks > 0 || pend.adds > 0; }
  function flush(leaving) {
    if (timer) { clearTimeout(timer); timer = 0; }
    if (!hasPending() || inflight) return;
    var snap = { seen: pend.seen, clicks: pend.clicks, adds: pend.adds };
    var body = JSON.stringify(payload());
    var cfg = { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: body };
    if (leaving) cfg.keepalive = true;
    var url = (window.routes && window.routes.cart_update_url) || '/cart/update.js';
    inflight = true;
    var done = function (ok, cart) {
      inflight = false;
      if (!ok) return;   /* keep the pending counts; the next tap or the page leaving tries again */
      pend.clicks -= snap.clicks; pend.adds -= snap.adds; if (snap.seen) pend.seen = false;
      var a = (cart && cart.attributes) || null;
      if (a) { known.seen = a._wtf_pairs_seen === '1' || a._wtf_pairs_seen === 1; known.clicks = num(a._wtf_pairs_clicks); known.adds = num(a._wtf_pairs_adds); }
      else { known.seen = true; known.clicks += snap.clicks; known.adds += snap.adds; }
      if (hasPending()) schedule();
    };
    try {
      fetch(url, cfg).then(function (r) { return r.ok ? r.json() : Promise.reject(new Error('cart ' + r.status)); })
        .then(function (c) { done(true, c); }, function () { done(false); });
    } catch (e) { done(false); }
  }
  function schedule() { if (!timer) timer = setTimeout(function () { timer = 0; flush(false); }, GAP); }

  function publish(kind, pos, card) {
    try {
      if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
        var btn = card && card.querySelector('[data-variant-id]');
        window.Shopify.analytics.publish('wtf_pairs_click', {
          kind: kind,
          position: pos,
          product_id: card ? card.getAttribute('data-product-id') : null,
          variant_id: btn ? btn.getAttribute('data-variant-id') : null,
          surface: 'cart_drawer'
        });
      }
    } catch (e) { /* no pixel listening is fine */ }
  }

  document.addEventListener('click', function (e) {
    try {
      var t = e.target && e.target.closest ? e.target : null;
      if (!t) return;
      var w = t.closest('[data-wtf-up]');
      if (!w) return;
      var kind = '', card = t.closest('.wtf-up__card'), pos = 0;
      if (t.closest('[data-wtf-up-prev]')) kind = 'arrow_prev';
      else if (t.closest('[data-wtf-up-next]')) kind = 'arrow_next';
      else if (card) {
        var k = t.closest('[data-wtf-kind]');
        kind = k ? k.getAttribute('data-wtf-kind') : '';
        pos = posOf(card);
        var link = t.closest('a[href]');
        if (link && pos) setParams(link, pos);   /* the link carries its position even if the stamp pass has not run yet */
      }
      if (!kind) return;
      pend.clicks++;
      publish(kind, pos, card);
      schedule();
    } catch (err) { /* never block the tap */ }
  }, true);

  /* A one-tap Add that the cart accepted (event sent by assets/wtf-drawer-v2.js). */
  document.addEventListener('wtf:pairs-added', function () {
    pend.adds++;
    schedule();
  });

  /* "Seen": the carousel is on screen, inside an OPEN drawer, with at least one card. */
  var io = null;
  function markSeen() {
    if (known.seen || pend.seen) return;
    pend.seen = true;
    schedule();
  }
  function drawerOpen() { var d = document.querySelector('cart-drawer'); return !!(d && d.classList.contains('active')); }
  if ('IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      for (var i = 0; i < entries.length; i++) {
        if (entries[i].isIntersecting && drawerOpen() && entries[i].target.querySelector('.wtf-up__card')) markSeen();
      }
    }, { threshold: 0.5 });
  }
  var queued = 0;
  function pass() {
    queued = 0;
    var list = document.querySelectorAll('#CartDrawer [data-wtf-up]');
    for (var i = 0; i < list.length; i++) {
      syncKnown(list[i]);
      stamp(list[i]);
      if (io && !list[i].hasAttribute('data-wtf-observed')) { list[i].setAttribute('data-wtf-observed', '1'); io.observe(list[i]); }
    }
  }
  function queue() { if (!queued) queued = requestAnimationFrame(pass); }
  var root = document.getElementById('CartDrawer');
  if (root && 'MutationObserver' in window) new MutationObserver(queue).observe(root, { childList: true, subtree: true });
  /* The drawer opening is a class change on <cart-drawer>: look again, so a carousel that was already on screen counts as seen. */
  var dr = document.querySelector('cart-drawer');
  if (dr && 'MutationObserver' in window) {
    new MutationObserver(function () {
      if (!drawerOpen()) return;
      var w = document.querySelector('#CartDrawer [data-wtf-up]');
      if (w && io) { io.unobserve(w); io.observe(w); }
    }).observe(dr, { attributes: true, attributeFilter: ['class'] });
  }
  queue();

  /* Send what is pending when the page hides or unloads (a Personalize / View tap leaves the page at once). */
  document.addEventListener('visibilitychange', function () { if (document.visibilityState === 'hidden') flush(true); });
  window.addEventListener('pagehide', function () { flush(true); });
})();
